import { DashboardPropertyReport } from "types/Reports";
import { getRequestHeaders, handleRes, logError } from "utils";

interface DashboardPropertyReportParams {
  tenantID: number | string | undefined;
  userID: number | string | undefined;
}

export const getDashboardPropertyReport = ({
  tenantID,
  userID,
}: DashboardPropertyReportParams): Promise<DashboardPropertyReport> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/user/${userID}/property-report`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<DashboardPropertyReport>(res, 200))
    .catch((e) => {
      logError(e);
      return { rows: [] };
    });
};
